module.exports = __webpack_public_path__ + "static/media/film-prod-nyc-1.2b3d96eb.jpeg";